import underFallskarm from '../assets/5 fallskarm/0 underFallskärm-small.jpg';
import underFallskarm_small from '../assets/5 fallskarm/0 underFallskärm-small.jpg';
import krafter from '../assets/5 fallskarm/1 krafter-small.jpg';
import krafter_small from '../assets/5 fallskarm/1 krafter-small.jpg';
import stall from '../assets/5 fallskarm/7 stall-small.jpg';
import stall_small from '../assets/5 fallskarm/7 stall-small.jpg';
import taSigHem from '../assets/5 fallskarm/2 taSigHem2-small.jpg';
import taSigHem_small from '../assets/5 fallskarm/2 taSigHem2-small.jpg';
import pavag from '../assets/5 fallskarm/5 påväg-small.jpg';
import pavag_small from '../assets/5 fallskarm/5 påväg-small.jpg';
import turbulens from '../assets/5 fallskarm/turbulens-small.jpg';
import turbulens_small from '../assets/5 fallskarm/turbulens-small.jpg';
import lekomrade from '../assets/5 fallskarm/4 lekområde.jpg';
import lekomrade_small from '../assets/5 fallskarm/4 lekområde.jpg';
import molnunderskarm from '../assets/5 fallskarm/6 moln/1 molnunderskarm-small.jpg';
import molnunderskarm_small from '../assets/5 fallskarm/6 moln/1 molnunderskarm-small.jpg';
import sparka from '../assets/5 fallskarm/6 sparka-small.jpg';
import sparka_small from '../assets/5 fallskarm/6 sparka-small.jpg';
import foretrade from '../assets/5 fallskarm/9 företräde-small.jpg'


import {
    faParachuteBox,
} from "@fortawesome/free-solid-svg-icons";

import { Image, DocsHeader, DocsHeading, DocsIntro, Section, Article, SectionHeader } from '../extra/Components'
import { Question, Questionary } from '../extra/Quiz';

const skarmQuiz = [
    Question.order("Kallotdrill", ["Dra!", "1000", "2000", "3000", "4000", "5000", "Kallottkontroll", "Kompiskontroll", "Höjdkontroll", "Orientering", "Lossa bromsarna", "Styr mot fältet"], []),
    Question.qManyA("Var uppstår finns turbulens på blåsiga dagar?", ["Nedvind av föremål", "Nära framför föremål", "Ovanför föremål", "Bakom träd", "Bakom byggnader"], ["Ovanför vatten", "Ovanför landningsbanan"]),
    Question.qManyA("Var uppstår finns turbulens vindstilla dagar", ["Ovanför landningsbana", "Ovanför taxibanor", "Ovanför mörka tak"], ["Ovanför vatten", "Bakom träd", "Nedvind om byggnader"]),
    Question.oneQ("Vilken höjd slutar lekområdet", "500m", ["300m", "400m", "600m"]),
    Question.oneQ("Vilken höjd börjar lekområdet", "Finns ingen övre gräns", ["500m", "1000m", "1500m"]),
    Question.oneQ("Var finns alltid turbulens oberoende av väder", "Bakom andra fallskärmar", ["Ovanför taxibanor", "Bakom träd", "Bakom byggnader"]),
    Question.oneQ("För att ta mig så långt som möjligt under fallskärm ska jag", "Göra mig så liten som möjligt för att minska parasitiskt luftmotstånd", ["Göra mig stor i medvind och liten i motvind", "Flyger normalt", "Svänger sick sack"]),
    Question.oneQ("Bromsad sväng använder jag för att", "Undvika hinder på låg höjd", ["Svänga på låg höjd", "Svänga i mitt landningsvarv", "Ta mig hem till fältet"]),
    Question.oneQ("Korrigeringar använder jag för att", "Undvika hinder på låg höjd", ["Svänga på låg höjd", "Svänga i mitt landningsvarv", "Ta mig hem till fältet"]),
    Question.oneQ("Om jag håller på att frontalkrocka med en annan hoppare svänger jag", "Höger", ["Vänster", "Inget, chicken race", "Neråt"]),
    Question.oneQ("När jag är blind i ett moln flyger jag i en långsam spiral genom att svänga åt", "Höger", ["Vänster", "Inget, chicken race", "Neråt"]),
    Question.oneQ("Om jag flyger bredvid en annan fallskärm och den sparkar med benen så ska jag", "Svara genom att också sparka med benen.", ["Kolla på hopparen", "Ropa att jag ser hen"]),
    Question.oneQ("Möter jag en hoppare på väg rakt mot mig väjer jag åt?", "Höger", ["Vänster", "Uppåt", "Neråt"]),
    Question.oneQ("Vad är prioriteten under fallskärm", "Ta sig till ett lämpligt landningsområde", ["Landa på fältet", "Landa så nära mitten av fältet som möjligt"]),
    Question.oneQ("Vad bör man göra om man känner att ens fallskärm är på väg att stalla", "Släppa upp bromsarna", ["Inget", "Dra ner bromsarna"]),
];

const underSkarmKallotdrill = <Section id="kallotdrill" name="Kallotdrill">
    <SectionHeader>Kallotdrill</SectionHeader>
    <p>En drill är en ramsa med ett handhavande men repeterar många gånger för att sen kunna
        genomföra korrekt. Kallotdrillen går från frifall till kallott flygning. Efter kallotdrillen
        avslutats ha man några minuter innan man behöver påbörja sitt landningsvarv som kommer
        senare. Kallotdrillen är som följer</p>
    <ol>
        <li><strong>...Dra</strong></li>
        <li><strong>1000</strong></li>
        <li><strong>2000</strong></li>
        <li><strong>3000</strong></li>
        <li><strong>4000</strong></li>
        <li><strong>5000</strong></li>
        <li><strong>Kallott kontroll</strong></li>
        <li><strong>Kompiskontroll</strong></li>
        <li><strong>Höjdkontroll</strong></li>
        <li><strong>Orientering</strong></li>
        <li><strong>Lossa bromsarna</strong></li>
        <li><strong>Styr mot fältet</strong></li>
    </ol>
    <h3>Upprepat med förklaringar</h3>
    <ol>
        <li><strong>Dra</strong>, sista i draget. Återgå till fallställning till fallskärmen tar
            över. Desto stabilare man är här desto bättre förutsättningar får fallskärmen att öppna
            korrekt.</li>
        <li><strong>1000</strong>, räkna sekunder för att ge fallskärmen lite tid att öppna sig</li>
        <li><strong>2000</strong></li>
        <li><strong>3000</strong></li>
        <li><strong>4000</strong></li>
        <li><strong>5000</strong> när fem sekunder ha gått så ska det finnas en fallskärm</li>
        <li><strong>Kallott kontroll</strong>, titta upp och se att fallskärmen är fungerande. Finns
            där ingen fallskärm så genomför man omedelbart reservdragsprocedur som kommer senare.
        </li>
        <li><strong>Kompiskontroll</strong>, Ser runt sig efter omedelbar kollisionsrisk. Om det
            förekommer kollisionsrisk med annan hoppare svängar man till höger för att undvika.</li>
        <li><strong>Höjdkontroll</strong>, dubbelkolla att du är på den höjd du tror.</li>
        <li><strong>Orientering</strong>, se var du är och var du ska.</li>
        <li><strong>Lossa bromsarna</strong> Ta tag i styrhandtagen och dra de försiktigt neråt till
            slacket löper upp.</li>
        <li><strong>Styr mot fältet</strong> Ta kurs åt vilket håll som är hem och styr fallskärmen
            ditåt.</li>
    </ol>
    <p>Här antar vi att fallskärmen öppnade korrekt. Fallen när den inte gör det tar vi senare i
        kapitlet felfunktioner.</p>
</Section>;

const underSkarmHurFlyger = <Section id="hurflyg" name="Hur flyger den">
    <SectionHeader>Hur flyger den</SectionHeader>
    <p>Moderna fallskärmar, vingfallskärmar, blåser upp sig utav luftmotståndet och formar en
        vingprofil. Vingprofiler bildar lyftkraft genom att färdas framåt genom lufthavet. För att
        manövrera oss drar vi i det högra styrhandtaget för att svänga höger, det vänstra för att
        svänga vänster och båda samtidigt för att bromsa.
    </p>
    <p>
        Med
        fallskärmar byter vi potentiell energi från gravitationen mot hastighet som ger oss
        lyftkraft från den relativa vinden.</p>

    <Image image={krafter} imageSmall={krafter_small} alt="Fallskärm som flyger" />

    <p>Den relativa vinden håller fallskärmen uppblåst genom cellöppningarna. Mer framåtfart ger mer
        lyftkraft från vingprofilen. Våra styrhandtag bromsar den sida man drar. Den går långsamma
        och fallskärmen svänger åt det hållet. Tar
        man båda två samtidigt byter man framåtfart mot lyftkraft. Det funkar till farten tar slut
        och sen tar fallskärmen fart igen. Tajmar man det rätt kan man ha minimal framåtfart och
        maximal lyft när man landar. Bromsar man för mycket tar fallskärmen slut på framåtfart
        vilket gör att den förlorar sin uppblåsning och kollapsar. Detta sker tillsammans med
        aerodynamisk stall som innebär att man förlorar lyftkraft.</p>

    <Image image={stall} imageSmall={stall_small} alt="Stall" />

    <p>En fallskärm som är på väg att stalla tappar sin form och böjer sig. Lösningen är att släppa
        upp bromsarna och få mer fart.</p>


    <p>När man svänger får man fallskärmen att dyka. Det ger mer hastighet neråt. Svänger man nära
        marken är det inte helt säkert att man hinner plana ut innan man träffar marken.</p>
    <p>Vill man göra en sväng utan att den dyker lika mycket kan man göra en bromsad sväng. Det
        innebär att man drar båda styrhandtag till axelhöjd så fallskärmen flyger halvbromsat.
        Därefter drar man den på den sida man vill svänga till lite längre ner. Bromsad sväng kan
        man använda ner till att man avslutar svängen på 50m. Man använder det för att undvika
        hinder. Ett hopp där allt går bra behöver man inte använda det. Är man för lågt när ens
        sväng är färdigt så gäller att man inte få bromsa mindre som vi kommer prata mer om i
        kapitlet om landning. Det innebär att man kan bromsa mer på den mindre bromsade sidan men
        man släpper inte upp och riskerar att fallskärmen dyker.</p>
    <p>Utöver bromsad sväng finns korrigering. Eller korrigerande sväng. Det är en sväng med litet
        input. Handtaget man på sidan man svänger mot förblir ovanför ens öra. Korrigeringar
        använder man om man behöver undvika hinder man ser under 100m. Har man inte ett hinder
        framför sig men tänker att man vill korrigera exakt mot vinden kommer pendeleffekter från
        små svängar sannolikt göra att man bara stör fallskärmens flygning och att det är bättre att
        bara landa lite snett.</p>
    <p>Om man skulle hamna på kollisionskurs med en annan hoppare svänger båda till sin egen höger
        för att undvika.</p>
</Section>;

const underSkarmTaSigHem = <Section id="tasighem" name="Ta sig hem">
    <SectionHeader>Ta sig hem</SectionHeader>

    <Image image={taSigHem} imageSmall={taSigHem_small} alt="Långspot" />

    <p>Absolut lättaste sättet att se till att man kommer hem till sitt planerade landningsområde är
        att hoppa av på rätt ställe (se spotting). Nästa steg är att snabbt efter fallskärmen
        vecklat ut sig styra åt rätt håll. Många utelandningar är för att folk flyger medvind och
        tänker på annat snarare än något oundvikligt.</p>
    <p>Generellt om man är långt från fältet är att man vill ge sin fallskärm ideala förhållanden
        för att flyga så effektivt som möjligt. Det första steget är att minimera parasitiskt
        luftmotstånd, luftmotstånd som inte ger lyftkraft. För ett fallskärmssystem är det så enkelt
        att hopparen står för det mesta parasitiska luftmotståndet. Dra upp sina ben och göra sig så
        liten som möjligt optimerar det.</p>
    <p>En fallskärm har ett glidtal. Förhållandet mellan hur många meter den sjunker mot hur många
        meter den tar sig framåt. Våra fallskärmar tar sig mer än två meter framåt för varje meter
        de sjunker i luften. Andra relevanta egenskaper är sjunkhastighet och framåtfart
        (självdriv). Som är hastigheterna neråt och framåt. En liten fallskärm kan ha ett högre
        glidtal men med högre framåthastighet och sjunkhastighet kommer den nå marken tidigare. Om
        vi drar lite i bakre bärremmarna ändrar vi riktning på fallskärmen och höjer glidtalet på
        bekostnad av hastighet. Flyger vi mot hård vind gör det att vår totala hastighet är
        självdriv minus vinden vilket kan resultera i att vi backar. Är det ingen vind kommer vi
        längre desto högre glidtal vi har och är där fördelaktigt att dra i bakre. Har vi stark
        medvind kan det vara optimalt att flyta med vinden så länge som möjligt. Då vill vi sänka
        våran sjunkhastighet så mycket som möjligt. Det gör vi genom att använda båda bromsar på
        ungefär
        halv broms.</p>
    <p>Vind är ett fenomen när luften rör sig relativt marken. I en fallskärm rör vi oss relativt
        luften och vinden vi upplever kommer vara identisk oberoende av vilket håll vi flyger
        relativt marken. Vårat enda sätt att veta hur det blåser är att kolla och memorera innan vi
        kliver in i flygplanet eller att jämför hur snabbt marken rör sig under oss när vi flyger i
        olika riktningar med våran fallskärm.</p>
    <p>Om man råkar hoppa av lång från landningsområdet (såsom på bilden) kallas det för långspot.
    </p>
    <h3>Var är man på väg</h3>
    <Image image={pavag} imageSmall={pavag_small} alt="Långspot" />

    <p>När man flyger utan att svänga så ser man att det under en rör sig förbi nedanför och det
        bortom rör sig uppåt mot horisonten. Mitt emellan de två är ett område som ser ut att
        finnas kvar på samma ställe. Det beskrivs som punkten som inte rör sig
        och är var man kommer landa ifall man inte ändrar något. Idealt vill man ha den punkten
        bortanför fältet så man har höjd till godo när man är framme. </p>
    <h3>Prioritet</h3>
    <p>Prioriteten under fallskärm är att ta sig till ett säkert landningsområde. Ett område utan
        hinder och turbulens. Första valet är hemma på fältet men det behöver inte vara det.
        Försöker man för länge ta
        sig till fältet kan man flyga förbi lämpliga landningsområden och vara ovanför olämpliga när
        man inser sin situation.</p>
</Section>;

const underSkarmTurbulens = <Section id="turbulens" name="Turbulens">
    <SectionHeader>Turbulens</SectionHeader>
    <Image image={turbulens} imageSmall={turbulens_small} alt="Turbulens" />

    <p>Turbulens är luft som virvlar. Det uppstår när vind passerar hinder såsom byggnader och träd.
        För fallskärmshoppare är turbulens farligt och något man bör undvika. När man flyger genom
        turbulens så skakar fallskärmen utav de olika vindarna den utsätts för. Är turbulensen
        kraftig nog så kan den till och med kollapsa hela eller delar av fallskärmen. Händer det
        nära marken är skaderisken stor. Turbulens uppträder bakom ovanför och framför hinder för
        vinden. Som tumregel minst dubbelt så högt som föremålet och fyra gånger så långt bakom som
        föremålet är högt. Desto hårdare det blåser desto större är dessa områden.</p>
    <p>En annan typ av turbulens som uppträder när det är vindstilla är termik. Luft som värms upp
        stiger. Detta sker ovan asfaltsytor och tak. Flyg inte över dessa på låg höjd soliga
        vindstilla dagar. Termik stiger uppåt och desto mer still vinden är desto högre når den.</p>
    <p>Hanteringen av turbulens är att alltid försöka hålla sig borta från riskzoner. Skulle man
        hamna i en position där
        man känner av turbulens så vill man ge fallskärmen så goda chanser som möjligt att klara
        störningarna genom att släppa upp bromsarna helt och maximera lufttrycket i cellerna.</p>
    <p>Den sista källan till turbulens är bakom andra fallskärmar. Man bildar ett spår av turbulens
        bakom sig. Flyg aldrig rakt bakom en annan fallskärm. Detta är extra viktigt på väg in för
        att landa. </p>
</Section>;

const underSkarmLekområde = <Section id="lekomrade" name="Lekområde">
    <SectionHeader>Lekområde</SectionHeader>
    <Image image={lekomrade} imageSmall={lekomrade_small} alt="Lekområde" />

    <p>Efter vi fullgjort våran kallotdrill och flyger hem mot fältet har vi gott om tid innan det
        är dags att påbörja sitt landningsvarv. Under den tiden håller vi oss i ett så kallat
        lekområde. Det är bara den del av fältet som ligger uppvind. Där håller vi oss tills vi
        kommer ner på höjd att det är dags att flyga in för att landa. Lekområdet slutar på
        <b>500m</b>
    </p>
</Section>;

const underSkarmMoln = <Section id="skarmmoln" name="Moln under fallskärm">
    <SectionHeader>Moln under fallskärm</SectionHeader>
    <Image image={molnunderskarm} imageSmall={molnunderskarm_small} alt="Moln under fallskärm" />

    <p>Huvudregeln är att vi inte flyger genom moln. Kan man är det bättre att flyga runt de. Hamnar
        man i ett moln vill man undvika att flyga in i andra fallskärmar som kan finnas i det. Det
        gör man genom att hålla sig på samma ställe. Flyger alla på samma ställe flyger ingen till
        någon annan. Bästa sättet att göra det är att hålla en långsam högersväng i en spiral neråt.
        Håll noga uppsyn ifall någon annan fallskärm skulle dyka upp. Har man koll på vad
        vindriktningen relativt solen var på marken kan man använda den ovanför molnen för att hålla
        kurs.</p>
</Section>;

const underSkarmKommunikation = <Section id="kommunikation" name="Trafikregler">
    <SectionHeader>Trafikregler</SectionHeader>
    <Image image={foretrade} />
    <p>
        Den övergripande trafikregeln under fallskärm är att den översta hopparen har väjningsplikt för en hoppare längre ner.
    </p>
    <p>
        I övrigt gäller allmänt hyfs:
    </p>
    <ul>
        <li>Flyg inte in framför någon.</li>
        <li>Landa inte för nära någon.</li>
        <li>Var förutsägbar</li>
    </ul>
    <h4>Kommunikation under skärm</h4>
    <Image image={sparka} imageSmall={sparka_small} alt="Sparka för att kommunicera" />

    <p>Under fallskärm är avstånden för långa och vindbrus för högt för att man ska effektivt kunna
        kommunicera med varandra. De verktyg vi har är att flyga förutsägbart och ha koll på övriga
        hoppare i luften. Ser man en hoppare som man inte är säker på ha sett en sparkar man med
        sina ben. Ser den andre hopparen det så sparkar denne med sina ben som svar. Då vet båda att
        båda har koll. Ser man en hoppare sparka och titta mot en så svarar man på samma sätt.</p>
    <p>
        Skulle man hamna i en situation där en frontalkrock föreligger, till exempel om man öppnat
        nära varandra, svänger båda hoppare åt sin höger. Är det inte frontalkrocksrisk håller man
        bort från andra hopparen.
    </p>
</Section>;

const UnderSkarm = ({ setSection, setArticle }) => (
    <Article name="Under fallskärm" icon={faParachuteBox} id="underskarm" setArticle={setArticle} setSection={setSection}>
        <DocsHeader>
            <DocsHeading note="Updaterad: 2022-07-13">Under fallskärm</DocsHeading>
            <Image image={underFallskarm} imageSmall={underFallskarm_small} alt="Dra din fallskärm" />

            <DocsIntro>
                <p>Andra delen utav fallskärmshoppet. Att ta sig ner till marken säkert. Fallskärmen kallas
                    ofta för skärm, kallott eller fallskärm och dessa begrepp kommer blandas här men betyder
                    alla samma sak. Det här avsnittet diskuterar handhavandet efter frifallet innan man
                    landar. Det tar vid omedelbart efter man dragit sin fallskärm</p>
            </DocsIntro>
        </DocsHeader>
        {underSkarmKallotdrill}
        {underSkarmHurFlyger}
        {underSkarmTaSigHem}
        {underSkarmTurbulens}
        {underSkarmLekområde}
        {underSkarmMoln}
        {underSkarmKommunikation}
        <Section id="fallskarm-quiz" name="Quiz">
            <SectionHeader>Quiz, under fallskärm</SectionHeader>
            <Questionary
                questions={skarmQuiz}
            />
        </Section>
    </Article>
);

export { UnderSkarm, skarmQuiz,  underSkarmKallotdrill, underSkarmHurFlyger, underSkarmTaSigHem, underSkarmTurbulens, underSkarmLekområde, underSkarmMoln, underSkarmKommunikation};